"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _getThemeProps.default;
  }
});

var _getThemeProps = _interopRequireDefault(require("./getThemeProps"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/getThemeProps/index.js
 ** module id = 210
 ** module chunks = 0
 **/